export default [
  '/bento',
  '/graphql',
  '/GeneralCommons',
];
